import { render, staticRenderFns } from "./BidTotalAmount.vue?vue&type=template&id=6545db86&scoped=true&"
import script from "./BidTotalAmount.vue?vue&type=script&lang=js&"
export * from "./BidTotalAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6545db86",
  null
  
)

export default component.exports